export default "__VITE_ASSET__CzxI7MhO__"